import { render } from "./CreateTrekInfo.vue?vue&type=template&id=51866626&scoped=true"
import script from "./CreateTrekInfo.vue?vue&type=script&lang=js"
export * from "./CreateTrekInfo.vue?vue&type=script&lang=js"

import "./CreateTrekInfo.vue?vue&type=style&index=0&id=51866626&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51866626"]])

export default __exports__